import React, { useState, useEffect } from 'react'
import Styles from './AddChargingTokenDesignModal.module.css'
import styled from 'styled-components'
import Colors from 'Theme/Colors'
import { useTranslation } from 'react-i18next'
import IFButton from 'Components/IFButton/IFButton'
import { TextField, FormGroup } from '@mui/material'
import { connect } from 'react-redux'
import { IFText } from 'Components'
import ChargingTokenDesignSelectors from 'Stores/ChargingTokenDesign/Selectors'
import ChargingTokenDesignActions from 'Stores/ChargingTokenDesign/Actions'
import PropTypes from 'prop-types'
import RequestState from 'Enums/RequestState'

const StyledTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: Colors.text,
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: Colors.grey,
      borderWidth: 1,
    },
    '&:hover fieldset': {
      borderColor: Colors.primary,
      borderWidth: 1,
    },
    '&.Mui-focused fieldset': {
      borderColor: Colors.primary,
      borderWidth: 1,
    },
  },
  width: '380px',
  '& .MuiInputBase-input': {
    height: '30px',
    padding: '10px',
  },
})

const AddChargingTokenDesignModal = ({
  addChargingTokenDesignRequestState,
  editChargingTokenDesign,
  editChargingTokenDesignRequestState,
  chargingTokenDesign,
  isEdit,
  addChargingTokenDesign,
}) => {
  const { t } = useTranslation()
  const [designName, setDesignName] = useState('')
  const [designDescription, setDesignDescription] = useState('')
  const [nameError, setNameError] = useState('')
  const [designError, setDesignError] = useState('')

  useEffect(() => {
    if (isEdit && chargingTokenDesign) {
      setDesignName(chargingTokenDesign.name || '')
    }
  }, [isEdit, chargingTokenDesign])

  const handleInputChange = (setter, errorSetter, value) => {
    setter(value)

    if (!isEdit) {
      if (value.trim() === '') {
        errorSetter(t('ChargingTokenPage.Required'))
      } else if (value.trim().length < 3) {
        errorSetter(t('ChargingTokenPage.MinThreeCharacters'))
      } else {
        errorSetter('')
      }
    } else {
      if (value.trim().length > 0 && value.trim().length < 3) {
        errorSetter(t('ChargingTokenPage.MinThreeCharacters'))
      } else {
        errorSetter('')
      }
    }
  }

  const handleBlur = (value, errorSetter) => {
    if (!isEdit) {
      if (value.trim() === '') {
        errorSetter(t('ChargingTokenPage.Required'))
      } else if (value.trim().length < 3) {
        errorSetter(t('ChargingTokenPage.MinThreeCharacters'))
      } else {
        errorSetter('')
      }
    } else {
      if (value.trim().length > 0 && value.trim().length < 3) {
        errorSetter(t('ChargingTokenPage.MinThreeCharacters'))
      } else {
        errorSetter('')
      }
    }
  }
  const handleSubmit = () => {
    let hasError = false

    if (designName.trim() === '') {
      setNameError(t('ChargingTokenPage.Required'))
      hasError = true
    } else if (designName.trim().length < 3) {
      setNameError(t('ChargingTokenPage.MinThreeCharacters'))
      hasError = true
    }

    if (!isEdit) {
      if (designDescription.trim() === '') {
        setDesignError(t('ChargingTokenPage.Required'))
        hasError = true
      } else if (designDescription.trim().length < 3) {
        setDesignError(t('ChargingTokenPage.MinThreeCharacters'))
        hasError = true
      }
    } else {
      if (
        designDescription.trim().length > 0 &&
        designDescription.trim().length < 3
      ) {
        setDesignError(t('ChargingTokenPage.MinThreeCharacters'))
        hasError = true
      } else {
        setDesignError('')
      }
    }

    if (hasError) return

    if (isEdit) {
      const updatedFields = {}

      if (designName.trim() !== chargingTokenDesign?.name) {
        updatedFields.name = designName
      }
      if (designDescription.trim().length > 0) {
        updatedFields.description = designDescription
      }

      if (Object.keys(updatedFields).length > 0) {
        editChargingTokenDesign(chargingTokenDesign._id, updatedFields)
      }
    } else {
      addChargingTokenDesign({
        name: designName,
        description: designDescription,
      })
    }
  }

  const isButtonDisabled =
    !designName.trim() ||
    designName.trim().length < 3 ||
    Boolean(nameError) ||
    Boolean(designError) ||
    (!isEdit &&
      (!designDescription.trim() || designDescription.trim().length < 3)) ||
    (isEdit &&
      (!designDescription.trim() || designDescription.trim().length < 3) &&
      designName.trim() === chargingTokenDesign?.name)

  return (
    <div className={Styles.Container}>
      <div className={Styles.FieldsDiv}>
        <div>
          <FormGroup className={Styles.InputWrappingDiv}>
            <IFText className={Styles.Labels}>
              {t('ChargingTokenPage.DesignName')}
            </IFText>
            <StyledTextField
              value={designName}
              onChange={(e) =>
                handleInputChange(setDesignName, setNameError, e.target.value)
              }
              onBlur={() => handleBlur(designName, setNameError)}
              error={Boolean(nameError)}
            />
          </FormGroup>
          <div
            style={{
              height: '10px',
              fontSize: '0.75rem',
              color: 'red',
            }}
          >
            {nameError && nameError}
          </div>
        </div>

        <div>
          <FormGroup className={Styles.InputWrappingDiv}>
            <IFText className={Styles.Labels}>
              {t('ChargingTokenPage.Design')}
            </IFText>
            <StyledTextField
              multiline
              maxRows={6}
              value={designDescription}
              onChange={(e) =>
                handleInputChange(
                  setDesignDescription,
                  setDesignError,
                  e.target.value,
                )
              }
              onBlur={() => handleBlur(designDescription, setDesignError)}
              error={Boolean(designError)}
            />
          </FormGroup>
          <div
            style={{
              height: '10px',
              fontSize: '0.75rem',
              color: 'red',
            }}
          >
            {designError && designError}
          </div>
        </div>
      </div>
      <IFButton
        size="sm"
        color={Colors.primary}
        isFill={true}
        text={
          isEdit ? t('ChargingTokenPage.Edit') : t('ChargingTokenPage.Save')
        }
        onClick={handleSubmit}
        className={Styles.SaveButton}
        isLoading={
          addChargingTokenDesignRequestState === RequestState.LOADING ||
          editChargingTokenDesignRequestState === RequestState.LOADING
        }
        isDead={isButtonDisabled}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  addChargingTokenDesignRequestState:
    ChargingTokenDesignSelectors.getAddChargingTokenDesignRequestState(state),
  editChargingTokenDesignRequestState:
    ChargingTokenDesignSelectors.getEditChargingTokenDesignRequestState(state),
})

const mapDispatchToProps = (dispatch) => ({
  addChargingTokenDesign: (design) =>
    dispatch(ChargingTokenDesignActions.addChargingTokenDesign(design)),

  editChargingTokenDesign: (id, design) =>
    dispatch(ChargingTokenDesignActions.editChargingTokenDesign(id, design)),
})

AddChargingTokenDesignModal.propTypes = {
  addChargingTokenDesignRequestState: PropTypes.number,
  addChargingTokenDesign: PropTypes.func,
  editChargingTokenDesign: PropTypes.func,
  editChargingTokenDesignRequestState: PropTypes.number,
  chargingTokenDesign: PropTypes.object,
  isEdit: PropTypes.bool,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddChargingTokenDesignModal)
